import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { FaShieldAlt, FaComments, FaKey, FaHistory, FaSignOutAlt, FaChevronRight } from "react-icons/fa";
import { ProductContext } from "../context/AppContext";
import { all_routes } from "../feature-module/router/all_routes";

const CommonSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const { userData, StudentProfileData, GetstudentData, Dashboarddata, getMenuList } = useContext(ProductContext) || {};
  const routes = all_routes;

  const isAdmitted = GetstudentData?.is_admitted === true || Dashboarddata?.data?.isAdmission === true;

  const dummyProfileImage = GetstudentData?.upload_photo?.link;
  const profileImage =
    StudentProfileData?.student_image?.trim() ||
    StudentProfileData?.profile_image?.trim() ||
    userData?.currentUser?.profileImage?.trim();
  const ProfilePhoto = dummyProfileImage || profileImage;

  const displayName =
    userData?.currentUser?.full_name ||
    userData?.currentUser?.username ||
    "User Name";

  const processedMenuList = useMemo(() => {
    const rawMenu = Array.isArray(getMenuList) ? getMenuList : [];
    return rawMenu.map((menu) => {
      const filteredSubitems = (menu?.submenuItems || []).filter((sub) => {
        const labelLower = (sub?.label || "").toLowerCase();
        if (
          labelLower.includes("staff") ||
          labelLower.includes("employee") ||
          labelLower.includes("teacher") ||
          labelLower.includes("hr")
        ) {
          return false;
        }
        return true;
      });

      return {
        ...menu,
        submenuItems: filteredSubitems,
      };
    }).filter((menu) => (menu?.submenuItems || []).length > 0);
  }, [getMenuList]);

  // const handleLogout = () => {
  //   try {
  //     localStorage.clear();
  //     localStorage.removeItem("token");
  //     localStorage.removeItem("siblings");

  //     if (window.ReactNativeWebView) {
  //       window.ReactNativeWebView.postMessage(
  //         JSON.stringify({
  //           type: "LOGOUT",
  //         })
  //       );
  //     }

  //     window.location.href = "/login";
  //   } catch (e) {
  //     console.error("Logout Error:", e);
  //   }
  // };

    const authtoken = localStorage.getItem("token");

  const handleLogout = async () => {
    try {
        const token = localStorage.getItem("token");
        // const fcmToken = localStorage.getItem("fcmToken");

        const fcmToken =
            localStorage.getItem("fcm_token") ||
            localStorage.getItem("fcmToken") ||
            localStorage.getItem("FCM_TOKEN");

        

        const isMobileApp = !!window.ReactNativeWebView;

        if (isMobileApp) {
            const response = await fetch(
                "https://api.mirai.healthcare/api/user/logout",
                {
                    method: "POST",
                    headers: {
                        Accept: "*/*",
                        "Content-Type": "application/json",
                        "x-auth": authtoken,
                    },
                    body: JSON.stringify({
                        fcm_token: fcmToken || "",
                    }),
                }
            );

            const data = await response.json().catch(() => null);

            console.log("Logout API Status:", response.status);
            console.log("Logout API Response:", data);

            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: "LOGOUT",
                })
            );
        }

        localStorage.clear();
        window.location.href = "/login";

    } catch (error) {
        console.error("Logout Error:", error);

        localStorage.clear();
        window.location.href = "/login";
    }
};
  return (
    <>
      {sidebarOpen && (
        <>
          <div
            className="sidebar-overlay"
            onClick={() => setSidebarOpen(false)}
          />

          <div className={`custom-sidebar ${sidebarOpen ? "open" : ""}`}>
            {/* Header */}
            <div className="sidebar-header">
              <img src={ProfilePhoto} className="sidebar-profile" alt="Profile" />

              <div>
                <h5>{displayName}</h5>
                {GetstudentData?.cls_sec?.cls?.Classes && (
                  <small>
                    Class {GetstudentData.cls_sec.cls.Classes} -{" "}
                    {GetstudentData.cls_sec.section.section}
                    {" • "}
                    Adm No: {GetstudentData.admission_num}
                  </small>
                )}
              </div>

              <button
                className="close-btn"
                onClick={() => setSidebarOpen(false)}
              >
                ×
              </button>
            </div>

            {/* Menu Items */}
            <div className="sidebar-menu">
              {!isAdmitted && processedMenuList && processedMenuList.length > 0 && (
                <div className="mb-3">
                  {processedMenuList.map((menulist, index) => {
                    const firstSubItem = menulist?.submenuItems?.[0] || menulist?.submenuItems;
                    const resolveRoute = (app_link) => {
                      if (typeof app_link === "string" && app_link.startsWith("routes.")) {
                        return app_link.replace("routes.", "");
                      }
                      return app_link;
                    };
                    const directRoute = firstSubItem?.app_link ? routes[resolveRoute(firstSubItem.app_link)] : null;
                    const targetRoute = directRoute || routes.information;
                    return (
                      <Link
                        key={index}
                        className="sidebar-item text-decoration-none d-flex align-items-center justify-content-between mb-1"
                        to={menulist?.submenuItems?.length === 1 ? targetRoute : routes.information}
                        state={{ id: menulist.id, label: menulist.label, submenuItems: menulist.submenuItems }}
                        onClick={() => setSidebarOpen(false)}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <i className={`${menulist.icon || 'ti ti-category'} text-primary`} />
                          <span>{menulist.label}</span>
                        </div>
                        <FaChevronRight className="small opacity-50" size={12} />
                      </Link>
                    );
                  })}
                  <div className="dropdown-divider my-2"></div>
                </div>
              )}

              {/* <a
                href="https://www.erishsolutions.com/schoolnavi-privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                className="sidebar-item text-decoration-none"
                onClick={() => setSidebarOpen(false)}
              >
                <div className="d-flex align-items-center gap-2">
                  <FaShieldAlt className="text-primary" />
                  <span>Privacy Policy – Erish</span>
                </div>
              </a> */}

              <Link
                to={routes.efeedback || "/efeedback"}
                className="sidebar-item text-decoration-none"
                onClick={() => setSidebarOpen(false)}
              >
                <div className="d-flex align-items-center gap-2">
                  <FaComments className="text-info" />
                  <span>E-feedbacks</span>
                </div>
              </Link>

              <Link
                to={routes.ResendPasswordHistory || "/ResendPasswordHistory"}
                className="sidebar-item text-decoration-none"
                onClick={() => setSidebarOpen(false)}
              >
                <div className="d-flex align-items-center gap-2">
                  <FaHistory className="text-success" />
                  <span>SMS/Email History</span>
                </div>
              </Link>

              <div
                className="sidebar-item logout text-danger"
                onClick={() => {
                  setSidebarOpen(false);
                  handleLogout();
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <FaSignOutAlt />
                  <span>Logout</span>
                </div>
              </div>
            </div>
          </div>
        </>

      )}
    </>
  );
};

export default CommonSidebar;